import state from './state.userAgent'
import mutations from './mutations.userAgent'
import getters from './getters.userAgent'
import actions from './actions.userAgent'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}